var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfilePromotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1615_96369)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1615_96369",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1615_96369)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1615_96369",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1615_96369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.24992 1.26609C4.63707 0.992199 5.11277 0.873273 5.58326 0.93276H5.74992C6.08417 0.938845 6.41326 1.01635 6.71509 1.16008C7.01692 1.30381 7.28452 1.51044 7.49992 1.76609C8.08326 2.51609 8.91659 3.76609 9.49992 4.68276H9.33326C8.08326 4.84943 5.83326 5.18276 4.91659 4.51609C4.58516 4.3108 4.3068 4.03027 4.1041 3.69725C3.90139 3.36423 3.78005 2.98812 3.74992 2.59943C3.70446 2.35273 3.72697 2.09831 3.81505 1.86343C3.90313 1.62855 4.05346 1.42207 4.24992 1.26609ZM15.9166 1.26609C16.2504 1.62854 16.4298 2.10685 16.4166 2.59943C16.3657 2.98236 16.2357 3.35052 16.0349 3.68049C15.834 4.01047 15.5667 4.29503 15.2499 4.51609C14.3333 5.18276 12.0833 4.84943 10.8333 4.68276H10.6666C11.2499 3.76609 12.0833 2.51609 12.6666 1.76609C13.1256 1.27978 13.7497 0.982555 14.4166 0.93276H14.5833C14.8162 0.883138 15.0574 0.887372 15.2885 0.94514C15.5196 1.00291 15.7344 1.11268 15.9166 1.26609ZM0.833257 9.18276V6.18276C0.829848 6.12715 0.838289 6.07146 0.858023 6.01936C0.877756 5.96726 0.908332 5.91995 0.947724 5.88056C0.987117 5.84117 1.03443 5.81059 1.08653 5.79086C1.13862 5.77112 1.19432 5.76268 1.24992 5.76609H9.66659V9.59943H1.58326V9.68276C1.49992 9.68276 1.41659 9.59943 1.24992 9.59943C1.19435 9.6027 1.13871 9.59417 1.08668 9.57438C1.03464 9.5546 0.987387 9.52402 0.948023 9.48466C0.908659 9.4453 0.87808 9.39804 0.858299 9.346C0.838517 9.29397 0.829983 9.23833 0.833257 9.18276ZM2.16659 10.6828H9.58326V19.0994H2.66659C2.58946 19.1014 2.51273 19.0876 2.44108 19.059C2.36942 19.0304 2.30434 18.9875 2.24978 18.9329C2.19522 18.8783 2.15232 18.8133 2.1237 18.7416C2.09507 18.67 2.08131 18.5932 2.08326 18.5161L2.16659 10.6828ZM10.6666 19.0169V10.6003H17.8333V18.4336C17.8352 18.5107 17.8214 18.5875 17.7928 18.6591C17.7642 18.7308 17.7213 18.7958 17.6667 18.8504C17.6122 18.905 17.5471 18.9479 17.4754 18.9765C17.4038 19.0051 17.3271 19.0189 17.2499 19.0169H10.6666ZM19.1666 9.18276C19.17 9.23836 19.1616 9.29406 19.1418 9.34616C19.1221 9.39825 19.0915 9.44557 19.0521 9.48496C19.0127 9.52435 18.9654 9.55493 18.9133 9.57466C18.8612 9.59439 18.8055 9.60284 18.7499 9.59943C18.6332 9.59574 18.5178 9.62459 18.4166 9.68276V9.59943H10.5833V5.76609H18.6666C18.7222 5.76268 18.7779 5.77112 18.83 5.79086C18.8821 5.81059 18.9294 5.84117 18.9688 5.88056C19.0082 5.91995 19.0388 5.96726 19.0585 6.01936C19.0782 6.07146 19.0867 6.12715 19.0833 6.18276L19.1666 9.18276Z",
    fill: "#9196AF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1615_96369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfilePromotion);
export default __webpack_public_path__ + "static/media/icon-profile-promotion.b928d6bb9e63730e985bd6792b973f2f.svg";
export { ForwardRef as ReactComponent };